@if (isLoaderVisible()) {
  <div class="global-loader-container">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}
